<template>
  <div class="popup-banner-container" />
</template>

<script>
export default {
  name: 'PopupBanner',
};
</script>

<style scoped>
</style>
